import request from "@/util/http";
/**
 * 列表
 */
export function goods_consultation_list(query) {
	return request({
		url: '/goods/shop/consultation/goods_consultation_list',
		method: 'get',
		params: query
	})
}

/**
 * 列表
 */
export function list_json(query) {
	return request({
		url: '/goods/shop/consultation/list_json',
		method: 'get',
		params: query
	})
}

/**
 * 删除
 */
export function del(params) {
	return request({
		url: '/goods/shop/consultation/delete',
		method: 'del',
		params: params
	})
}


/**
 * 发表
 */
export function add(query) {
	return request({
		url: '/goods/shop/consultation/add',
		method: 'get',
		params: query
	})
}

/**
 * 详情
 */
export function detail(query) {
	return request({
		url: '/goods/shop/consultation/detail',
		method: 'get',
		params: query,
	})
}

/**
 * 保存
 */
export function save(query) {
	return request({
		url: '/goods/shop/consultation/save',
		method: 'post',
		params: query,
	})
}


// module.exports = {
// 	goods_consultation_list,
// 	list_json,
// 	del,
// 	add,
// 	detail,
// 	save,
// }
